module.exports = __webpack_public_path__ + "img/midShadow-wide-card.96138b3b.svg";